import HeroLayout from "../../../Components/LayoutContainers/HeroLayout";
import MDBox from "../../../Components/MDBox";
import EsBan from "../../../Asset/images/MAqImage.png";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Grid, TablePagination} from "@mui/material";
import Asd1 from "../../../Asset/images/asd1.png";
import Asd2 from "../../../Asset/images/asd2.png";
import Asd3 from "../../../Asset/images/asd3.png";
import PDfdo from "../../../Asset/images/pdfdo.png";
import Attachment from "../../../Asset/images/attachment.png";
import MDTypography from "../../../Components/MDTypography";
import {setLoading, useMaterialUIController} from "../../../Context/mui";
import {AttachmentsModel} from "../../../Api/Model/AttachmentsModel";
import Cookies from "js-cookie";
import {ErrorToaast} from "../../../utils/toast/Toast";
import MDButton from "../../../Components/MDButton";

export default function StudentAmoozshi() {
    const [page, setPage] = useState(null)
    const navigate = useNavigate();
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [counter, setCounter] = useState(0)
    const [controller, dispatch] = useMaterialUIController();
    const {loading} = controller;
    let Api = new AttachmentsModel(Cookies.get("cst") ?? "");

    function defaultLabelDisplayedRows({from, to, count}) {
        return `${from}–${to} از ${
            count !== -1 ? count : `بیشتر از ${to}`
        }`;
    }

    const [rows, setRows] = useState({
        content: [],
        pageSize: 0,
        totalPages: 0,
    });
    useEffect(() => {
        if (page != null) {
            console.log(page)

            setLoading(dispatch, true);
            Api
                .GetAttachments(page, pageNumber, pageSize)
                .then((r) => {
                    setRows(r.data.data);
                })
                .catch
                (r => {
                    if (r?.status == 404) {
                        setLoading(dispatch, false)

                        return
                    }
                    ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
                    setLoading(dispatch, false)

                })
                .finally(() => {
                    setLoading(dispatch, false);
                });
        }


    }, [pageNumber, pageSize, counter, page]);
    const handleChange = (event, newValue) => {
        setCounter(p => p + 1);
    };
    const handleChangePage = (event, newPage) => {
        event.preventDefault();

        setPageNumber(newPage + 1);
    };
    const handleChangeRowsPerPage = (
        event
    ) => {
        event.preventDefault();

        setPageSize(+event.target.value);
        setPageNumber(1);
    };
    return <HeroLayout>
        <MDBox mx={{xs: 2, md: 10, lg: 10}} mt={4}>
            <MDBox sx={{justifySelf: "center", cursor: "pointer"}} onClick={() => setPage(null)}>
                <img src={EsBan} style={{height: "15vh"}}/>
            </MDBox>
            {page === null && <>
                <MDBox sx={{justifySelf: "center"}} pb={5}>
                    <Grid container textAlign={"center"} gap={5} mt={5}>
                        <Grid item xs={12} sx={{cursor: "pointer"}}
                              onClick={() => setPage(0)}>
                            <img src={Asd1} style={{height: "30vh"}}/>
                        </Grid>
                        <Grid item xs={12} sx={{cursor: "pointer"}}
                              onClick={() => setPage(1)}>
                            <img src={Asd2} style={{height: "30vh"}}/>
                        </Grid>
                        <Grid item xs={12} sx={{cursor: "pointer"}}
                              onClick={() => setPage(2)}>
                            <img src={Asd3} style={{height: "30vh"}}/>
                        </Grid>
                        <Grid item xs={12} sx={{cursor: "pointer"}}
                              onClick={() => navigate("/studentlanding")}>
                            <MDTypography sx={{fontSize: "40px"}}>بازگشت</MDTypography>
                        </Grid>
                    </Grid>
                </MDBox>
            </>}
            {page === 0 && <>
                <Grid container spacing={2} mt={2}>
                    {rows?.content?.map(video => (
                        <Grid container direction={"column"} item xs={12} sm={6} key={video.id}>
                            <Grid container item alignItems={"center"} justifyContent={"space-between"}
                                  sx={{background: "white", p: 1, borderRadius: "10px 10px 0 0"}}>
                                <Grid item>
                                    <MDTypography sx={{lineBreak: "anywhere"}}>
                                        {video?.title}
                                    </MDTypography>
                                </Grid>
                                <Grid item>
                                    <MDButton onClick={() => window.open(Api.DownloadFile(video?.id), "_blank")}
                                              variant={"text"} color={"warning"}>
                                        دانلود
                                    </MDButton>

                                </Grid>
                            </Grid>
                            <Grid item flex={1} minHeight={100}>
                                <video width="100%" height="100%" controls preload="auto" controlsList="nodownload">
                                    <source src={Api.DownloadFile(video?.id)}
                                            type="video/mp4"/>
                                    مرورگر شما ویدیو ساپورت نمیکند
                                </video>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </>}
            {page === 1 && <>
                <Grid container spacing={2} mt={2}>
                    {rows?.content?.map(video => (
                        <Grid container direction={"column"} item xs={12} sm={12} key={video.id}>
                            <Grid container item alignItems={"center"}
                                  sx={{background: "white", p: 1, borderRadius: "10px "}}>
                                <Grid item px={2}>
                                    <img height={50} width={50} src={PDfdo}/>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDTypography sx={{lineBreak: "anywhere"}}>
                                        {video?.title} ({video?.fileName})
                                    </MDTypography>
                                </Grid>
                                <Grid item>
                                    <MDButton size={"large"}
                                              onClick={() => window.open(Api.DownloadFile(video?.id), "_blank")}
                                              variant={"text"} color={"warning"}>
                                        دانلود
                                    </MDButton>

                                </Grid>
                            </Grid>

                        </Grid>
                    ))}
                </Grid>
            </>
            }
            {page === 2 && <>
                <Grid container spacing={2} mt={2}>
                    {rows?.content?.map(video => (
                        <Grid container direction={"column"} item xs={12} sm={12} key={video.id}>
                            <Grid container item alignItems={"center"}
                                  sx={{background: "white", p: 1, borderRadius: "10px "}}>
                                <Grid item px={2}>
                                    <img height={50} width={50} src={Attachment}/>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDTypography sx={{lineBreak: "anywhere"}}>
                                        {video?.title} ({video?.fileName})
                                    </MDTypography>
                                </Grid>
                                <Grid item>
                                    <MDButton size={"large"}
                                              onClick={() => window.open(Api.DownloadFile(video?.id), "_blank")}
                                              variant={"text"} color={"warning"}>
                                        دانلود
                                    </MDButton>
                                    
                                </Grid>
                            </Grid>

                        </Grid>
                    ))}
                </Grid>
            </>
            }
            {page !== null && <>
                {rows?.content.length > 0 && (
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={rows.totalPages}
                        rowsPerPage={pageSize}
                        page={pageNumber - 1}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelDisplayedRows={defaultLabelDisplayedRows}
                        labelRowsPerPage={<>تعداد در هر صفحه</>}
                    />
                )}
            </>}
        </MDBox>
    </HeroLayout>
}